import { create } from "zustand";

import { globalCreateTaskSlice } from "./slice";
import type { ZGlobalCreateTask } from "./types";

export const useGlobalCreateTaskStore = create<ZGlobalCreateTask>()(
  (...args) => ({
    ...globalCreateTaskSlice(...args),
  }),
);
